import React from 'react';
export function Footer() {
  return <footer className="bg-nutri-black text-gray-400 py-12 border-t border-white/10" data-id="element-83">
      <div className="container mx-auto px-4 text-center" data-id="element-84">
        <div className="mb-6" data-id="element-85">
          <span className="text-white font-bold text-xl tracking-tight" data-id="element-86">
            NUTRI<span className="text-nutri-cta" data-id="element-87">PRO KIT</span>
          </span>
        </div>

        <p className="mb-2" data-id="element-88">
          © 2026 NutriPro Kit — Todos los derechos reservados
        </p>
        <p className="mb-8" data-id="element-89">
          Contacto:{' '}
          <a href="mailto:Soportetusbeneficios@gmail.com" className="text-nutri-mint hover:underline" data-id="element-90">
            Soportetusbeneficios@gmail.com
          </a>
        </p>

        <div className="max-w-2xl mx-auto text-xs text-gray-500 leading-relaxed" data-id="element-91">
          Disclaimer: Este producto es una herramienta administrativa
          profesional. No reemplaza el criterio clínico del profesional de la
          nutrición.
        </div>
      </div>
    </footer>;
}